import { Text } from "@overmap-ai/blocks"
import { computeModelIndex, type Issue } from "@overmap-ai/common"
import { selectIssueById, selectIssueTypeById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { useAppSelector } from "../../store"
import type { BaseIndexLabelProps } from "./typings"

interface IssueIndexLabelProps extends BaseIndexLabelProps {
	issueId: Issue["uuid"]
}

export const IssueIndexLabel = memo((props: IssueIndexLabelProps) => {
	const { className, issueId, ...rest } = props

	const issue = useAppSelector(selectIssueById(issueId))

	if (!issue) {
		throw new Error(`Could not find issue ${issueId} for submission.`)
	}

	const issueType = useAppSelector(selectIssueTypeById(issue.issue_type ?? ""))!

	return (
		<Text className={cx("shrink-0 text-nowrap", className)} {...rest}>
			{computeModelIndex(issueType, issue)}
		</Text>
	)
})
IssueIndexLabel.displayName = "IssueIndexLabel"
